<style scoped>
@import '../components/Styling/common.scss';
</style>

<template>
  <div>
    <div class="adminPage">
      <center>
        <h1 class="pt-3" style="margin: 30px auto">
          insdi<a style="font-size: 0.99em; color: #e14eca"> Designer Console</a>
        </h1>
      </center>
      <div style="width: 750px; margin: auto auto">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="5000"
          controls
          indicators
          background="#ababab"
          img-width="512"
          img-height="300"
          style="text-shadow: 1px 1px 2px #333"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
            caption="Refer and Earn"
            text="We will remunerate you if a referral becomes a client within 6 months"
            img-src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1173&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          >
          </b-carousel-slide>
          <b-carousel-slide
            caption="No coding skills required"
            text="It's as simple as using a spreadsheet"
            img-src="https://picsum.photos/1024/680/?image=1005"
          >
          </b-carousel-slide>
          <b-carousel-slide
            img-src="https://picsum.photos/1024/680/?image=373"
            caption="Mobile first"
            text="Let clients interact with you on their terms."
          >
          </b-carousel-slide>
          <b-carousel-slide
            img-src="https://picsum.photos/1024/680/?image=660"
            caption="Design and deploy immediately"
            text="No long specifications or meetings. Build, test and deploy in minutes."
          >
          </b-carousel-slide>
          <!--b-carousel-slide img-src="https://picsum.photos/1024/680/?image=528"
          caption="Design and deploy immediately"
          text="No long specifications or meetings. Build, test and deploy in minutes." >
        </b-carousel-slide-->
          <b-carousel-slide
            img-src="https://picsum.photos/1024/680/?image=58"
            caption="Secure"
            text="Leveraging the latest protocols to ensure your data is safe."
          >
          </b-carousel-slide>
        </b-carousel>
      </div>
      <center>
        <h5 style="margin: 20px auto">
          Need help? Contact us <a style="color: black" href="mailto:support@insdi.com">here</a>.
        </h5>
      </center>
      <center>
        <h5>
          Not a member? Visit our
          <a href="https://www.insdi.com" target="_blank" style="text-decoration: none">website</a>
          for more details
        </h5>
        <h5>
          By using this service, you agree to our
          <router-link to="/TermsAndConditions"> Terms and Conditions</router-link>
        </h5>
      </center>
    </div>
  </div>
</template>

<script>
export default {
  name: 'landingPage',
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    }
  }
}
</script>
